import { useAtomValue } from 'jotai';
import { Box, Backdrop, CircularProgress } from '@mui/material';

import { pageAtom, isBackdropOpenAtom } from '../atoms';
import { Snackbar } from '../sharedComponents';
import { Header } from './components';
import { PAGE } from '../constant/page';
import * as Pages from '../screens';

const pageComponentMapping = {
  [PAGE.LOGIN]: Pages.LoginPage,
  [PAGE.MAIN]: Pages.MainPage,
  [PAGE.TERMS_OF_USE]: Pages.TermsOfUsePage,
  [PAGE.TERMS_OF_USE_UPDATE]: Pages.TermsOfUsePage,
  [PAGE.REGISTRATION]: Pages.RegistrationPage,
  [PAGE.REACTIVATION]: Pages.EmailEntryPage,
  [PAGE.CHANGE_PASSWORD]: Pages.EmailEntryPage,
  [PAGE.CHANGE_PASSWORD]: Pages.EmailEntryPage,
  [PAGE.REACTIVATION_MAIL]: Pages.SentEmailPage,
  [PAGE.REGISTRATION_MAIL]: Pages.SentEmailPage,
  [PAGE.CHANGE_PASSWORD_MAIL]: Pages.SentEmailPage,
};

const ScreenRouter = () => {
  const page = useAtomValue(pageAtom);
  const isBackdropOpen = useAtomValue(isBackdropOpenAtom);

  const PageContent = pageComponentMapping[page] || null;

  return (
    <Box
      width='100%'
      height='100vh'
      display='flex'
      overflow='auto'
      flexDirection='column'
      bgcolor='#f5f5f5'
    >
      <Header />
      {PageContent && <PageContent />}
      <Snackbar />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 3 }}
        open={isBackdropOpen}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </Box>
  );
};

export default ScreenRouter;
